module.exports = __webpack_public_path__ + "img/JP.69743c58.jpg";